import { DescriptionRequest } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { DescriptionResponseEditor, servicePreformattedEditor } from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.model'
import axios from 'axios'

class PreformattedDiagnosisServices implements servicePreformattedEditor<DescriptionResponseEditor> {
    async getPreformatted(laboratoryId: number, preformattedId : number): Promise<DescriptionResponseEditor> {
        const response = await axios.get<DescriptionResponseEditor>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/diagnosis`)
        return response.data
    }
    async updatePreformatted(laboratoryId: number, preformattedId : number, request: DescriptionRequest): Promise<DescriptionResponseEditor> {
        const response = await axios.put<DescriptionResponseEditor>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/diagnosis`, request)
        return response.data
    }
    async updatePreformattedAndSolveExistingCodification(laboratoryId: number, preformattedId : number, replaceInsteadOfAdd: boolean, request: DescriptionRequest): Promise<DescriptionResponseEditor> {
        const response = await axios.put<DescriptionResponseEditor>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}/diagnosis/solveCodificationsChange`, request, { params: { replaceInsteadOfAdd } })
        return response.data
    }
}

export const preformattedDiagnosisServices = new PreformattedDiagnosisServices()
